<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <l-map style="width: 100%; height: 700px" :zoom="zoom" :center="center" ref="map">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-polygon
          v-for="item in map_items"
          :key="item.id"
          :lat-lngs="item.polygon.latlngs"
          :color="item.polygon.color"
        >
          <l-tooltip :options="{ permanent: false, interactive: false, direction: 'bottom' }">
            {{ item.main_seller }} ({{ item.id }})
          </l-tooltip>
        </l-polygon>
      </l-map>
    </template>
  </div>
</template>

<script>
import { getLandPurchaseContractMap } from '@/http'
import { LMap, LTileLayer, LPolygon, LTooltip } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

export default {
  name: 'LandPurchaseContractMap',
  components: { LMap, LTileLayer, LPolygon, LTooltip },
  data() {
    return {
      is_loaded: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      zoom: 15,
      center: [-3.174138888888889, 37.22464166666667],
      map_items: [],
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getLandPurchaseContractMap()
        .then(res => {
          this.map_items = res.data
          this.is_loaded = true
        })
    }
  }
}
</script>

<style lang="sass">
.leaflet-control-attribution
  display: none

.leaflet-marker-icon:focus-visible, .vue2leaflet-map
  outline: none

.leaflet-tooltip-bottom
  margin-top: 14px

.leaflet-tooltip-top:before, .leaflet-tooltip-bottom:before, .leaflet-tooltip-left:before, .leaflet-tooltip-right:before
  content: none

.leaflet-tooltip
  padding: 4px 8px 3px
  border-radius: 3px
  color: #000
</style>